<template>
  <div>
    <nav class="bar bar-nav">
      <a class="button button-link button-nav pull-left"  @click="gotolast()" v-if="showGo">
        <span class="icon icon-left"></span>返回
      </a>
    </nav>

    <div class="content">
      <div class="content-inner">
        <div class="list-block media-list" style="margin-top: 10px;margin-bottom: 0">
          <ul>
            <div class = "orderTitle">填写订单</div><div class = "blueTitle"></div>
            <li class="orderInfo" >收货地址</li>
            <li v-for="(address,index) in filterAddress">
              <router-link :to="{name : 'address', params:{order: order}}" class="item-link item-content">
                <div class="item-inner" style="padding: 0 0 0 2rem">
                  <div class="item-title-row">
                    <div class="item-title" >{{address.consignee}}</div>
                  </div>
                  <div class="item-subtitle">{{address.expressAddress}}</div>
                  <div class="item-text">{{address.expressMobile}}</div>
                </div>
              </router-link>
            </li>
            <li class="orderInfo">

              <span>订单信息</span>
              <a class="alert-text" @click="displayMessage1()">

                <img :src="questionUrl" style="width: .9rem;"></img>

              </a>
            </li>

          </ul>
        </div>
        <div class="list-block media-list" style="margin: 5px 5% 0 5%; width: 90%" v-for="merchandise in orderList">
          <ul>
            <li>
              <a @click=goToDetail(merchandise) class="item-link item-content">

                <div class="item-media"></div>
                <div class="item-inner">

                  <!--<div  style="height: 60px;margin: 10px 0 10px 0;">-->
                    <!--<div style="border: #2ac845">-->
                      <!--<span style="font-size: 0.7rem;border: thin solid black;color: white;background-color: black; padding: 0.2rem"-->
                            <!--v-if="merchandise._attributesList[1]" >-->
                        <!--{{merchandise._attributesList[1].valueText}}</span>-->
                      <!--<span style="font-size: 0.9rem;color: black;" v-if="merchandise._attributesList[2]">-->
                        <!--{{merchandise._attributesList[2].valueText}}</span>-->
                    <!--</div>-->
                    <!--<span style="left:0; bottom:0;font-size: 1.3rem;color: black;padding-left:0.3rem;font-weight: bold"-->
                          <!--v-if="merchandise._attributesList[0]">-->
                      <!--{{merchandise._attributesList[0].valueText}}-->
                    <!--</span>-->
                  <!--</div>-->

                  <div  style="margin-top: 1rem;border-bottom:1px solid #1a1a1a; padding-top: 0.5rem">
                    <div style="border: #2ac845; padding-bottom: .5rem">
                      <span v-if="merchandise._subTitleList && merchandise._subTitleList.length > 0" v-for="subTitle in merchandise._subTitleList">
                        <span style="position:relative;color: white;background-color: white; padding: 0.1rem;"></span>
                        <span style="font-size: 0.7rem;color: white;background-color: #00469A;padding: 0.1rem;" v-if="subTitle.valueText !== '-1' && subTitle.value !== '-1' ">{{subTitle.valueText}}</span></span>

                     <span style="font-size: 0.9rem;color: black;" v-if="merchandise._abstractList && merchandise._abstractList.length>0"
                           v-for="abstractTitle in merchandise._abstractList">
                       <span v-if="abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1' ">  <span v-if="abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined">{{abstractTitle.valueText.TLNo}}</span><span v-else>{{abstractTitle.valueText}}</span></span></span>
                    </div>

                    <span style="left:0; bottom:0;font-size: 1.2rem;color: #3F3F3F;padding:0.2rem 0 0.2rem 0;font-weight: bold"
                          v-if="merchandise._titleList && merchandise._titleList.length > 0" v-for="title in merchandise._titleList">
                     <span v-if="title.valueText !== '-1' && title.value !== '-1'"><span v-if="title.columnName === 'TVInfo'">{{title.valueText.TLNo}}</span><span v-else>{{title.valueText}}</span></span>
                    </span>
                    <div v-if="merchandise.selfOperated === 0" style=" margin-top: 10px;">
                      <span style="font-size: x-small;color: #1482E7">【代购】</span>
                    </div>
                  </div>

                  <!--<div class="item-title-row">-->
                    <!--<div>{{ merchandise.merchandiseLabel}}</div>-->
                  <!--</div>-->
                  <div  class="item-title-row" v-if="merchandise.discountPrice && merchandise.discountPrice !==0 && !isUseSpecialFundCoupon">
                    <div class="item-title" style="color: #6e727b">折扣</div>
                    <div lass="item-after" style="color: #00469A;font-size: 0.1rem"> ￥<span style="font-size: 1.3rem">{{merchandise.discountPrice}} </span></div>
                  </div>
                  <div class="item-title-row">
                    <div class="item-title" style="color: #6e727b" v-if="!merchandise.productQuantity && merchandise.quantity === 0">合计1个产品</div>
                   <div class="item-title" style="color: #6e727b"  v-else>合计{{merchandise.productQuantity ? merchandise.productQuantity : merchandise.quantity}}个产品</div>
                    <div lass="item-after" style="color: #00469A;font-size: 0.1rem">
                      ￥<span style="font-size: 1.3rem" v-if="isSFFlag">{{merchandise.priceMax}} </span>
                      <span style="font-size: 1.3rem" v-else-if="merchandise.price && merchandise.price !== 0">{{merchandise.price}} </span>
                      <span style="font-size: 1.3rem" v-else-if="merchandise.priceMin">{{merchandise.priceMin}} </span>
                      <span style="font-size: 1.3rem" v-else>{{merchandise.priceMax}} </span>
                    </div>  </div>
                </div>

              </a>
            </li>
          </ul>
        </div>

        <slot></slot>


        <div class="list-block media-list" style="margin-top: 0px;margin-bottom: 10px;font-size:14PX" >
          <!-- 隐藏蓝v计划 -->
          <!-- <ul>
            <li  v-if="ifcanUseVipPlanBouns === true && showpromotion === true">
              <div class="item-title-row" style="margin-top: 0.5rem;margin-bottom: 0.5rem">
                <div class="item-title" style="padding-left: 1.8rem">
                  是否参与蓝V会员计划
                  <a class="alert-text" @click="displayMessage3()">

                    <img :src="questionUrl" style="width: .9rem"></img>

                  </a>
                </div>


                <div lass="item-after" style="padding-right: 1rem;">
                  <div>
                    <label class="label-switch">
                      <input id ="VipPlanBouns" type="checkbox" v-model="isUseVipPlanBouns"  disabled @change="changeUseIfVipPlanBouns" checked>
                      <div class="checkbox" ></div>
                    </label>
                  </div>
                </div>
              </div>
            </li>
          </ul> -->
          <!-- <ul>
            <li  v-if="isUseVipPlanBouns  && showpromotion === true">
              <div class="item-title-row" style="margin-top: 0.5rem;margin-bottom: 0.5rem">
                <div class="innviceContent"  style="margin-left: 20px"  >
                  <div style="margin-left: 15px;">选择蓝V会员账户</div>
                  <div v-for="(vip,index) in VipPlanList" v-if="VipPlanList.length > 1">
                    <label class="label-checkbox item-content">
                      <input type="radio" name="vipradio" :value="vip.vipguid" @click="yanzheng(index)">
                      <div class="item-media"><i class="icon icon-form-checkbox"></i>
                        <span style="margin-left: 10px">{{vip.customerPlanName}}</span>
                      </div>
                    </label>
                  </div>
                  <div v-for="(vip,index) in VipPlanList" v-else>
                    <label class="label-checkbox item-content">
                      <input type="radio" name="vipradio" :value="vip.vipguid" @click="yanzheng(index)" checked>
                      <div class="item-media"><i class="icon icon-form-checkbox"></i>
                        <span style="margin-left: 10px">{{vip.customerPlanName}}</span>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </li>
          </ul> -->
          <ul>
              <div class="item-content">
                <div class="item-inner">
                  <div class="item-title-row">
                    <div class="item-title" style="padding-left: 1rem">
                      选择不发货
                        <a class="alert-text" @click="displayMessage">
                          <img :src="questionUrl" style="width: 1.4rem; padding-left:.3rem"></img>
                        </a>
                    </div>


                    <div lass="item-after" style="padding-right: 1rem;">
                      <div>
                        <label class="label-switch">
                          <input id ="express" type="checkbox" v-model="isExpress" @change="changeExpressFree">
                          <div class="checkbox"></div>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="item-title-row" v-if="isSFFlag && !isUseSpecialFundCoupon" style="margin-bottom: 8px;margin-top: 8px">
                    <div class="item-title" style="padding-left: 1rem">
                      不使用优惠券
                    </div>

                    <div lass="item-after" style="padding-right: 1rem;">
                      <div>
                        <label class="label-switch">
                          <input id ="coupon_refused" type="checkbox" v-model="couponRefused" @change="changeCouponRefused">
                          <div class="checkbox"></div>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="item-title-row">
                    <div class="item-title" style="padding-left: 1rem">商品金额</div>
                    <div class="item-after" style="padding-right: 1rem;color: #00469A">
                      <span class="expressPrice">￥</span>
                      <span class="expressMoney" >{{goodsMoney}}</span>
                    </div>
                  </div>

                  <div class="item-title-row" v-if="discountPrice && !isUseSpecialFundCoupon">
                    <div class="item-title" style="padding-left: 1rem">折扣</div>
                    <div class="item-after" style="padding-right: 1rem;color: #00469A">
                      <span class="expressPrice">-￥</span>
                      <span class="expressMoney">{{discountPrice}}</span>
                    </div>
                  </div>

                  <div class="item-title-row" style="margin-bottom: 1rem" v-if="expressPrice && expressPrice > 0">

                    <div class="item-title" style="padding-left: 1rem">
                      运费
                      <a class="alert-text" @click="displayMessage2()">
                        <img :src="questionUrl" style="width: 1.4rem; padding-left:.3rem"></img>
                      </a>
                    </div>
                    <div class="item-after" style="padding-right:1rem; color: #00469A">
                      <span class="expressPrice">+￥</span>
                      <span class="expressMoney">{{expressPrice}}</span>
                    </div>
                  </div>
                  <div style="height: 1.2rem;">
                  </div>
                </div>
              </div>
          </ul>
        </div>
      </div>
    </div>
    <footer class="bar  bar-tab" style="height:3rem">
      <div class="item-media" >
        <div class="tab-item" >
          <span class="tab-label">实支付</span>
          <span class="expressPrice" style="color: black;">￥</span>
          <span style="font-size: 1.3rem;color: black;">{{totalMoney.toFixed(2)}}</span>

          <section>
            <span v-if="showButton && showBtn" class="buttonStyle" @click="response">{{buttonName}}</span>
            <span class="buttonStyle" style="background-color: gainsboro" v-else>{{buttonName}}</span>
          </section>
        </div>

      </div>
    </footer>
  </div>

</template>

<script>
  import $ from 'jquery'
  import {mapState, mapMutations, mapGetters} from 'vuex'
  import emkt from '../../../emkt'
  export default {
    mounted () {
      if (this.$route.params && this.$route.params.order) {
        $('#express')[0].disabled = true
      }
      var _this = this
      _this.fetchTotalMoney()
      // if (emkt.getLocalStorage('VipPlanList') !== null) {
      //   var list = emkt.getLocalStorage('VipPlanList')
      //   for (var i in list) {
      //     if (list[i].type === 1) {
      //       _this.VipPlanList.push(list[i])
      //       _this.ifcanUseVipPlanBouns = true
      //     }
      //   }
      //   if (_this.VipPlanList.length === 1) {
      //     _this.isUseVipPlanBouns = true
      //     _this.customerVipPlanNo = _this.VipPlanList[0].GUID
      //   //  _this.fetchTotalMoney()
      //   }
      //   // if (list[i].applicationNumber > 0 && list[i].type === 1) {
      //   //   _this.gcapi('presentVirusNum', list[i].GUID).then(function (response) {
      //   //     if (response.body.result) {
      //   //       _this.VipPlanList.push(list[i])
      //   //       _this.ifcanUseVipPlanBouns = true
      //   //     }
      //   //   })
      //   // }
      //   _this.fetchTotalMoney()
      // } else {
      //   _this.fetchTotalMoney()
      // }
    },
    created () {
      this.address = this.sessionInfo.expressAddress
      if (this.checkList.length === 0) {
        if (this.order.merchandises.length === 0) {
          for (let i in this.order.subOrders) {
            for (let j in this.order.subOrders[i].merchandises) {
              this.orderList.push(this.order.subOrders[i].merchandises[j])
            }
          }
//          this.orderList = this.order.subOrders.merchandises
        } else {
          this.orderList = this.order.merchandises
        }
      } else {
        this.orderList = this.checkList
      }
//      this.orderList = this.checkList.length === 0 ? this.order.merchandises : this.checkList
      this.orderNum = this.orderList.length
      if (this.address === undefined) {
        $.toast('请登录')
        return
      }
//      this.fetchTotalMoney()
//      this.orderList.push(this.cartList[this.goodId])
    },

    props: ['buttonName', 'order', 'coupons', 'selectCoupon', 'productInfo', 'showButton', 'showpromotion'],

    data () {
      return {
        orderList: [],
        limitNum: 1,
        goodId: null,
        address: [],
        goodsMoney: 0,
        totalMoney: 0,
        orderNum: 0,
        expressPrice: 0,
        isUseVipPlanBouns: false,
        ifcanUseVipPlanBouns: false,
        baseurl: '/emktResources/resocurces/img/merchandise/',
        questionUrl: '/emktResources/resocurces/img/question.png',
        discountPrice: 0,
        isExpress: false,
        VipPlanList: [],
        customerVipPlanNo: '',
        getAllAvailableCouponsAlready: false,
        couponRefused: false,
        specialFundCouponUsed: false,
        showBtn: true
      }
    },
    watch: {
      'order.price': function (val) {
        this.discountPrice = this.order.discountPrice.toFixed(1)
        this.totalMoney = parseFloat(this.order.totalPrice)
        this.goodsMoney = this.order.initPrice
      },
      'order.initPrice': function (val) {
        this.totalMoney = parseFloat(this.order.totalPrice)
        this.discountPrice = this.order.discountPrice.toFixed(1)
        this.goodsMoney = this.order.initPrice
      },
      selectCoupon (val) { // 选择免邮券后，重新计算价格
        if (val.type !== 0) {
          this.fetchTotalMoney()
        }
      }
    },
    methods: {
      ...mapMutations([
        'REMOVE_ALL_CHECKLIST_FROM_CART_LIST'
      ]),
      // changeUseIfVipPlanBouns () {  //蓝v计划
      //   this.customerVipPlanNo = ''
      //   if (this.isUseVipPlanBouns === false) {
      //     this.fetchTotalMoney()
      //   } else {
      //     if (this.VipPlanList.length === 1) {
      //       this.customerVipPlanNo = this.VipPlanList[0].GUID
      //       this.fetchTotalMoney()
      //     }
      //   }
      // },
      // yanzheng (optionIndex) {       //蓝v计划
      //   $.each(this.VipPlanList, function (index, item) {
      //     item.checked = false
      //   })
      //   this.VipPlanList[optionIndex].checked = true
      //   this.customerVipPlanNo = this.VipPlanList[optionIndex].GUID
      //   this.fetchTotalMoney()
      // },
      displayMessage () {
        $.alert('如果选择发货，商品将直接寄送给您；如果选择不发货，商品将留在吉凯基因用于您的其他服务项目。')
      },
      displayMessage1 () {
        $.alert('1、您订单中的所有商品会一起运出，因此需要等待最后一份商品生产完成后统一发货。如果您急需其中的某个产品，您可以分批下单。<br>' +
        '2、订单提交后，系统将自动开具发票，发票抬头内容即为您实际采购的产品明细。<br>' +
       '3、当您下了多个订单时，不能进行合并订单操作。如有特殊情况，请与我们的工作人员联系处理（400-621-0302）。')
      },
      displayMessage2 () {
        $.alert('配送病毒或者冻存细胞等产品时，需要用到大量的干冰来保持产品的稳定性和活性，配送质粒和支原体试剂盒时，' +
          '需要用冰袋保持产品活性。我们将选择最佳的产品包装和最有保障的物流配送，' +
          '将优质产品快速送到您手中。当订单含多个产品时我们仅收取一次费用。')
      },
      displayMessage3 () {
        $.alert('订单提交后，该订单将享受相应蓝V会员账户权益。！')
      },
      changeCouponRefused() {
        this.fetchTotalMoney()
      },
      changeExpressFree () {
        var self = this
        if (self.isExpress === false) {
          self.fetchTotalMoney()
        } else {
          $.confirm('如果选择不发货，商品将留在吉凯基因用于您的其他服务项目。',
            function () {
              $.showIndicator()
              setTimeout(function () {
                $.hideIndicator()
              }, 300)
              self.fetchTotalMoney()
            },
            function () {
              self.isExpress = false
            })
        }
      },
      response () {
        const _this = this
        if (this.buttonName === '确认下单') {
          console.log('isNewCustomerWithoutHistoryOrders', this.isNewCustomerWithoutHistoryOrders)
          let preSaleText = ''
          if (this.isPreSaleOrder()) {
            preSaleText = '本产品为预售产品，3月初发货，请知悉! 如有疑问可联系在线客服或业务员！<br>'
          }
          let showText = `<div><span style="color: #ff0000">${preSaleText}</span> 请您仔细核对订单信息（包括物品，发票，发货地址，发货方式和结算方式）
           确认订单后吉凯将尽快对您的订单进行审核，审核通过之前，您仍旧可以在“我的”界面中的“待收货”模块下找到您的订单。</div>`
          $.modal({
            text: showText,
            buttons: [
              {
                text: 'Cancel',
                onClick: function () {
                }
              },
              {
                text: 'OK',
                onClick: function () {
                  $.showIndicator()
                  setTimeout(function () {
                    $.hideIndicator()
                  }, 300)
                  _this.$emit('response')
                }
              }
            ]
          })
        } else {
          _this.$emit('response')
        }
      },
      isPreSaleOrder () {
        const preSalePeriod = []
        emkt.christmasPreSalePeriod.forEach((timeString) => {
          preSalePeriod.push(new Date(timeString))
        })
        console.log('presaleperiod', preSalePeriod)
        const now = new Date()
        let isPreSale = false
        if (now > preSalePeriod[0] && now < preSalePeriod[1]) {
          isPreSale = true
          console.log('first day, all orders are pre sale orders')
        } else if ((now > preSalePeriod[2] && now < preSalePeriod[3]) || (now > preSalePeriod[4] && now < preSalePeriod[5])) {
          console.log('second/third day, new customers\' orders are pre sale orders')
          isPreSale = this.isNewCustomerWithoutHistoryOrders
        }
        console.log('is pre sale', isPreSale)
        return isPreSale
      },
      getProductInfo () {
        var self = this
        let border = {}
        if (this.address === undefined) {
          $.toast('请登录')
          return
        } else {
          let addr = this.filterAddress[0]
          if (!addr && this.isSFFlag === false) {
            $.modal({
              title: '请先添加收货地址',
              buttons: [
                {
                  text: '确定',
                  onClick: function () {
                    self.$router.push({name: 'address', params: {order: self.order}})
                  }
                }]
            })
            return
          }
          if (this.isSFFlag === false) {
            border.expressAddress = addr.city + addr.district + addr.expressAddress
            border.expressPhone = addr.expressMobile
            border.expressContactor = addr.consignee
            border.isSingleExpress = true
          } else {
            border.expressAddress = ''
            border.expressPhone = ''
            border.expressContactor = ''
            border.isSingleExpress = true
          }
        }
        let coupons = []
        let coupon = this.selectCoupon
        if (coupon) {
          if (this.selectCoupon.type !== 0) {
            coupons.push(coupon)
          }
        }
        border.coupons = coupons

        let bMerchandises = []
        if (this.orderList === undefined) {
          $.toast('读取数据失败')
          return
        }
        if(emkt.getUrlParamHref('fromSmart') === '1') {
          border.isSmartOrder = true
          border.bsmartProducts =[]
          this.orderList.forEach(item=>{
            let pro={
              guid: item.guid,
              smartProductParameterSelection: item.smartProductParameterSelection
            }
            let bMerchandise = {}
            bMerchandise.price = item.price
            bMerchandise.expressPrice = item.expressPrice
            bMerchandise.merchandiseGuid = item.guid
            bMerchandise.workdays = item.workdays
            bMerchandise.priceMax =  item.price
            bMerchandise.priceMin =  item.price
            bMerchandise.unitPrice =  item.price
            bMerchandise.initPrice =  item.price
            bMerchandise.SKUID = item.SKUID
            bMerchandise.productName = item.productName
            bMerchandise.productGuid = item.productGuid
            bMerchandise.muGuid = item.muGuid
            bMerchandise.isSmartMerchandise = true
            bMerchandise.attributes = item.smartAttributes
            bMerchandises.push(bMerchandise)
            border.bsmartProducts.push(pro)
          })
        } else {
          for (let i = 0; i < this.orderList.length; i++) {
            let bMerchandise = {}
            let order = this.orderList[i]

            if (order.categoryId !== 10) {
              bMerchandise.merchandiseGuid = order.merchandiseId
            } else {
              if (order.merchandiseId.toString().indexOf('Customized01') === -1) {
                alert('提交商品中包含审核失败的报价，请您修改商品再提交审核')
                this.$router.push({name: 'cart'})
                return
              }
              bMerchandise.merchandiseGuid = order.goodsNo
              bMerchandise.merchandiseId = order.goodsNo
            }
            if (order.id) {
              bMerchandise.orderGuid = order.id
            }
            if (this.isSFFlag) {
              bMerchandise.unitPrice = order.priceMax
            } else {
              bMerchandise.unitPrice = order.priceMin
            }
            if(order.hardGeneDescription) {
              bMerchandise.hardGeneDescription = order.hardGeneDescription
            }
            bMerchandise.selfOperated = order.selfOperated
            bMerchandise.customerGuid = this.sessionInfo.customerInfo.customerGuid
            bMerchandise.quantity = order.productQuantity
            bMerchandise.merchantNo = order.MerchantNo
            bMerchandise.amplification = order.amplification
            bMerchandise.categoryId = order.categoryId
            bMerchandise.priceMax = order.priceMax
            bMerchandise.priceMin = order.priceMin
            bMerchandise.initPrice = bMerchandise.quantity * bMerchandise.unitPrice
            let productGuid = order.productGuid
            if (productGuid) {
              bMerchandise.productGuid = productGuid
            }
            let cusGuid = order.expressPrice
            if (cusGuid) {
              bMerchandise.expressPrice = cusGuid
            }
            let attributes = []
            Object.keys(order.attributes).forEach(function (key) {
              if (order.attributes[key] instanceof Object) {
                if (key === 'GeneInfo') {
                  attributes.push({key: key, value: order.attributes[key].geneGUID})
//                attributes.push({key: 'NMID', value: order.attributes[key].NMID})
                }
                if (key === 'TVInfo') {
                  attributes.push({key: key, value: order.attributes[key].TLNo})
                }
              } else {
                attributes.push({key: key, value: order.attributes[key]})
              }
            })
            bMerchandise.attributes = attributes

            bMerchandises[i] = bMerchandise
          }
        }

        border.merchandises = bMerchandises
        border.expressFree = this.isExpress
        border.usedBonus = false
        border.customerVipPlanNo = this.customerVipPlanNo
        if (emkt.isWapp) {
          border.clientSource = '3'
        } else {
          border.clientSource = '1'
        }
        self.productInfo.value = border
        return border
      },
      fetchTotalMoney () {
        this.showBtn = false
        var self = this

        let bMerchandises = this.getProductInfo()
        if (!bMerchandises) {
          return
        }
        if (emkt.isWapp) {
          bMerchandises.clientSource = '3'
        } else {
          bMerchandises.clientSource = '1'
        }
        if (this.$route.query && this.$route.params.order) {
          let result = this.$route.params.order
          this.goodsMoney = result.price
          this.expressPrice = result.expressPrice
          this.totalMoney = result.totalPrice
          this.discountPrice = result.discountPrice ? Math.abs(+result.discountPrice) : 0
          this.isExpress = result.expressFree
          this.isUseVipPlanBouns = false
        } else {
          if (this.isSFFlag) {
            // 将sf跳转链接的参数传给后台
            const paymentInfo = {}
            paymentInfo.balanceType = emkt.getUrlParam('BalanceType') === '' ? 0 : emkt.getUrlParam('BalanceType')
            paymentInfo.payType = emkt.getUrlParam('PayType')
            paymentInfo.firstLevelEnterpriseNo = emkt.getUrlParam('FirstLevelEnterpriseNo')
            paymentInfo.firstLevelEnterpriseName = emkt.getUrlParam('FirstLevelEnterpriseName')
            paymentInfo.secondLevelEnterpriseNo = emkt.getUrlParam('SecondLevelEnterpriseNo')
            paymentInfo.secondLevelEnterpriseName = emkt.getUrlParam('SecondLevelEnterpriseName')
            paymentInfo.researchGroupNo = emkt.getUrlParam('ResearchGroupNo')
            paymentInfo.researchGroupName = emkt.getUrlParam('ResearchGroupName')
            paymentInfo.settlementAccountNo = emkt.getUrlParam('SettlementAccountNo')
            bMerchandises.sfQuoteId = this.sessionInfo.customerInfo.customerProperties['QuoteId']
            bMerchandises.employeeNo = this.sessionInfo.customerInfo.employeeOnBehalf
            bMerchandises.orderSource = '2'
            bMerchandises.clientSource = '1'
            bMerchandises.orderType = '1'
            bMerchandises.merchantNo = '101'
            Object.assign(bMerchandises, paymentInfo)
            if(this.couponRefused) {
              bMerchandises.coupons = []
            }
          }
          $.showPreloader('正在计算中')
          this.gcapi('calculateOrderAmount', bMerchandises).then(data => {

            let result = data.body.result
            var useSpecialCoupon = false
            var notShare = false
            for (var i = 0; i < result.merchandises.length; i++) {
              for (var j = 0; j < this.productInfo.value.merchandises.length; j++) {
                if (result.merchandises[i].merchandiseGuid === this.productInfo.value.merchandises[j].merchandiseGuid) {
                  this.productInfo.value.merchandises[j].remark = result.merchandises[i].remark
                }
              }
              if (result.merchandises[i].perferPromotions) {
                for (var k = 0; k < result.merchandises[i].perferPromotions.length; k++) {
                  if (result.merchandises[i].perferPromotions[k].requiredCustomers === 1) {
                    var pro = result.merchandises[i].perferPromotions[k]
                    let endDT = new Date(pro.endDT.year, pro.endDT.month, pro.endDT.dayOfMonth, pro.endDT.hourOfDay, pro.endDT.minute, pro.endDT.second)
                    let statrDT = new Date(pro.startDT.year, pro.startDT.month, pro.startDT.dayOfMonth, pro.startDT.hourOfDay, pro.startDT.minute, pro.startDT.second)
                    let startDT1 = this.FormatterTime(statrDT).replace(/-/g, '/')
                    let endDT1 = this.FormatterTime(endDT).replace(/-/g, '/')
                    var newcoupon = {
                      'promotionGuid': pro.promotionGuid,
                      'code': this.sessionInfo.customerInfo.customerNo + pro.promotionGuid,
                      'customerNo': this.sessionInfo.customerInfo.customerNo,
                      'type': 0,
                      'label': pro.name,
                      'startDT': startDT1,
                      'endDT': endDT1,
                      'description': pro.description
                    }
                    if (result.merchandises[i].perferPromotions[k].description.includes('不同享')) {
                      notShare = true
                    }
                    useSpecialCoupon = true
                    result.coupons.push(newcoupon)
                    break
                  } else {
                    if (result.merchandises[i].perferPromotions[k].description.includes('不同享')) {
                      result.coupons = result.coupons.filter(coupon => {  // 一旦有免单券则不过滤
                        return coupon.type === 4
                      })
                      break
                    }
                  }
                }
              }
              // SF跳转下单，折扣券和代金券可以一起使用
              if (((useSpecialCoupon && this.isSFFlag === false) || notShare)) {
                result.coupons = result.coupons.filter(coupon => {  // 非SF下单，一旦有折扣券则其他全券不可使用
                  return coupon.type === 0
                })
              }
            }
            if (!this.selectCoupon) {
              this.filterCoupons(result)
            }
                // console.log(this.productInfo)
            this.totalMoney = 0
            this.goodsMoney = 0
            this.expressPrice = 0
            this.specialFundCouponUsed = result.specialFundCouponUsed
            var isedit = false
            for (var n in bMerchandises.merchandises) {
              if (bMerchandises.merchandises[n].orderGuid) {
                isedit = true
              }
            }
            if (isedit) {
              if (this.isSFFlag) {
                for (var m in bMerchandises.merchandises) {
                  this.goodsMoney = this.goodsMoney + bMerchandises.merchandises[m].initPrice
                  if (bMerchandises.merchandises[m].expressPrice) {
                    this.expressPrice = this.expressPrice + bMerchandises.merchandises[m].expressPrice
                  }
                }
                if (bMerchandises.expressFree) {
                  this.expressPrice = 0
                }
                this.totalMoney = this.expressPrice + this.goodsMoney
              } else {
                this.goodsMoney = result.price
                this.totalMoney = result.totalPrice
                this.expressPrice = result.expressPrice
              }
            } else {
              this.goodsMoney = result.price
              this.totalMoney = result.totalPrice
              this.expressPrice = result.expressPrice
            }
            var couponlist = []
            for (let j = 0; j < result.coupons.length; j++) {
              var flag = true
              couponlist.forEach(item => {
                if (result.coupons[j].code === item.code) {
                  flag = false
                }
              })
              if (flag) {
                couponlist.push(result.coupons[j])
              }
            }
            // 首次可选择优惠券
            if (!this.getAllAvailableCouponsAlready) {
              this.coupons.value = couponlist
              this.getAllAvailableCouponsAlready = true
            }
                // 计算特殊的打折券的折扣金额
            const specialcouponpromotions = emkt.getLocalStorage('EmktSpecialcouponpromotions')
            let specialDiscountPrice = 0
            if (specialcouponpromotions && specialcouponpromotions.length > 0) {
              const specialCouponPromotionGuids = specialcouponpromotions.map(pro => pro.promotionGuid)
              result.merchandises.forEach(merchandise => {
                const preferPromitionGuid = merchandise.perferPromotions && merchandise.perferPromotions.length > 0 && merchandise.perferPromotions[0].promotionGuid
                specialDiscountPrice += (preferPromitionGuid && specialCouponPromotionGuids.includes(preferPromitionGuid)) ? merchandise.discountPrice : 0
              })
            }
            console.log('specialDiscountPrice', specialDiscountPrice)
            this.discountPrice = result.discountPrice ? Math.abs(+result.discountPrice) + Math.abs(+specialDiscountPrice) : (specialDiscountPrice ? Math.abs(+specialDiscountPrice) : 0)
//            if (this.discountPrice < 1 && this.isUseVipPlanBouns) {
//              alert('您好，此订单中的商品不符合赠送条件，请勿使用赠送名额！')
//              this.isUseVipPlanBouns = false
//              $.each(this.VipPlanList, function (index, item) {
//                item.checked = false
//              })
//              this.customerVipPlanNo = ''
//              this.fetchTotalMoney()
//            }
            if (+this.totalMoney < 0) {
              $.modal({
                title: '订单出现异常，请联系客服',
                buttons: [
                  {
                    text: '确定',
                    onClick: function () {
                      self.$router.go(-1)
                    }
                  }]
              })
            }
            $.hidePreloader()
            this.showBtn = true
          }).catch(e=>{
            $.hidePreloader()
          })
        }
      },
      goToDetail (product) {
        let id = product.categoryId
        let cId
        if (product.merchandiseDetailForClient) {
          cId = product.merchandiseDetailForClient.categoryId
        }
        let mId = product.merchandiseId
        if (id !== 10 && cId !== 10) {
          if (id === 20 || cId === 20) {
            this.$router.push({name: 'FinderOrderDeail', params: {merchandises: product, id: 1, order: this.order}})
          } else {
            this.$router.push({name: 'finderMerchandises', query: { id: product.merchandiseId === undefined ? product.merchandiseGuid : product.merchandiseId }, params: {order: this.order}})
          }
//          this.$router.push({name: 'merchandises', query: { id: product.merchandiseId === undefined ? product.merchandiseGuid : product.merchandiseId }})
        } else {
          if (mId) {
            this.$router.push({name: 'custDetail', query: {custom: mId}, params: {order: this.order}})
          } else {
            this.$router.push({name: 'custDetail', query: { custom: product.merchandiseDetailForClient._attributesList }, params: {order: this.order}})
          }
        }
      },
      gotolast () {
        this.$router.push({name: 'cart'})
      },
      containExpressCoupon (coupons) {
        return coupons.some(coupon => {
          return coupon.label.indexOf('免邮券') !== -1 || coupon.label.indexOf('折券') !== -1
        })
      },
      setAvailableCoupons (result) {
        if (!result.coupons || result.coupons.length === 0) return
        // 折扣券
        if (this.containExpressCoupon(result.coupons)) {
          if (result.coupons.length === 1) {
            $.toast('已为您选择折扣券！')
            this.$emit('updateSelectCoupon', result.coupons[0])
          }
        }
        // 优惠券和促销不同享时，使用免邮券来抵消运费
        if (this.containExpressCoupon(result.coupons)) {
          result.coupons = result.coupons.filter(coupon => {  // 过滤出金额比订单运费少的免邮券
            return coupon.label.includes('免邮券') && coupon.value <= result.expressPrice
          })
          result.coupons.sort((a, b) => {
            return b.value - a.value
          })
          console.log('sorted coupons', result.coupons)
          if (result.coupons[0]) {  // 默认选择第一个免邮券后，更新selectCoupon以重新计算价格
            if (!this.selectCoupon || this.selectCoupon.label !== result.coupons[0].label) {
              console.log('需计算最新价格')
              $.toast('已为您选择免邮券，正在重新计算价格')
              this.$emit('updateSelectCoupon', result.coupons[0])
            }
          }
        } else {
          result.coupons = []
        }
      },
      filterCoupons (result) {
        if (!result.coupons || result.coupons.length === 0) return
        if(this.couponRefused) {
          return
        }
        // 需过滤掉大于邮费的免邮券, 并选择最优的优惠券
        // const expressPrice = result.expressPrice
        // result.coupons = result.coupons.filter(coupon => {  // 过滤掉大于邮费的免邮券
        //   return !(coupon.label.includes('免邮券') && coupon.value > expressPrice)
        // })
        // 按优惠券金额倒序排列
        result.coupons.sort((a, b) => {
          return b.value - a.value
        })
        if (result.coupons[0]) {  // 默认选择最优优惠券后，更新selectCoupon以重新计算价格
          if (!this.selectCoupon || this.selectCoupon.label !== result.coupons[0].label) {
            console.log('需计算最新价格')
            $.toast('已为您选择优惠券，正在重新计算价格')
            this.$emit('updateSelectCoupon', result.coupons[0])
          }
        }
      },
      FormatterTime (date) {
        let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
        let currentDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
        let currenthours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
        let currentMinutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
        let currentSeconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
        var newTime = date.getFullYear() + '-' + month + '-' + currentDate + ' ' + currenthours + ':' + currentMinutes + ':' + currentSeconds
        return newTime
      }
    },
    computed: {
      ...mapState([
        'checkList', 'sessionInfo'
      ]),
      ...mapGetters([
        'isNewCustomerWithoutHistoryOrders', 'isSFFlag'
      ]),
//    过滤
      filterAddress () {
        var self = this
        if (this.address === undefined) {
          $.modal({
            title: '请先登录',
            buttons: [
              {
                text: '确定',
                onClick: function () {
                  self.$router.push({name: 'login'})
                }
              }]
          })
          return []
        }
        let add = []
        this.address.forEach(function (item) {
          if (item.isDefault && add.length < self.limitNum) {
            add.push(item)
          }
        })
        if (add.length < self.limitNum) {
          this.address.forEach(function (item) {
            if (!item.isDefault && add.length < self.limitNum) {
              add.push(item)
            }
          })
        }
        if (add.length === 0 && this.isSFFlag === false) {
          $.modal({
            title: '请先添加收货地址',
            buttons: [
              {
                text: '确定',
                onClick: function () {
                  self.$router.push({name: 'address', params: {order: self.order}})
                }
              }]
          })
          return []
        }
        emkt.setStoreItem('filterAddress', add)
        return add
      },
      isUseSpecialFundCoupon() {
        console.log('this.selectCoupon')
        return this.selectCoupon && this.selectCoupon.type && this.selectCoupon.type === 6
      },
      showGo() {
        return !(emkt.getUrlParamHref('fromSmart') === '1')
      }
    }
  }
</script>

<style type="text/css">
  .check-step {
    /*padding: 5px 0;*/
  }
  .buttonStyle{
    color: white;
    position: absolute;
    right: 0;
    background-color: #045aa5;
  @include wh(5rem, 100%);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -42px;
    width: 100px;
    height: 56px;
  }
  .check-step ul {
    display: -ms-flexbox;
    display: flex;
    margin: 25px 0 50px 0; }
  .check-step ul:after {
    visibility: hidden;
    display: block;
    content: " ";
    clear: both; }
  .check-step li {
    position: relative;
    float: left;
    -ms-flex: 1;
    flex: 1;
    width: 33%;
    line-height: 1.5em;
    padding: 0 1em 1em 1em;
    border-bottom: 2px solid #ccc;
    color: #999;
    font-size: 16px;
    text-align: center; }
  .check-step li:after {
    position: absolute;
    bottom: -7px;
    left: 50%;
    margin-left: -7px;
    content: "";
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #ccc; }
  .check-step li.cur {
    border-color: #EE7A23;
    color: #EE7A23;
    list-style-type:none}
  .check-step li.cur:after {
    background: #EE7A23; }

  @media only screen and (max-width: 767px) {
    .check-step ul {
    margin-left: -20px;
    margin-right: 20px; }
    .check-step li {
      font-size: 12px; } }

  .checkout-title {
    position: relative;
    margin-bottom: 10px;
    margin-top: 10px;
    text-align: center; }
  .checkout-title span {
    position: relative;
    padding: 0 1em;
    background-color: #EFEFF4;
    font-family: "moderat", sans-serif;
    font-weight: bold;
    font-size: 16px;
    color: #605F5F;
    z-index: 1; }
  .checkout-title:before {
    position: absolute;
    top: 50%;
    left: 0;
    content: "";
    width: 100%;
    height: 1px;
    background: #ccc;
    z-index: 0; }

  .orderTitle {
    margin-top: 0.5rem;
    text-align: center;
    color: #00469A;
    font-weight: bold;
    border-bottom: 1px solid #dddddd;
  }
  .blueTitle {
    width: 4rem;
    border-bottom: 2px solid #00469A;
  }
  .orderInfo {
    color: #00469A;
    font-size: 0.75rem;
    font-weight: bold;
    padding: 0.5rem  0 0.5rem 1.9rem;
  }
  .expressPrice {
    padding-top: 0.3rem;
    font-size: 0.5rem;
  }
  .expressMoney {
    font-size:1rem
  }
</style>



// WEBPACK FOOTER //
// Order.vue?48388781